module.exports = __webpack_public_path__ + "img/zone3schedule.677e77dc.png";